<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [MensajeMostrar]="this.textoMostrar" [TituloMostrar]="this.tituloBoton" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row pr-0 pl-3 mt-5 reactivaciónAfiliado">
    <div class="row pr-0">
        <div class="col-md-10 col-10">
            <h2 class="titleppal">{{this.tituloEstado}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="col-2 cerrarafil text-right">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
        <div [formGroup]="form" fxFlex="auto" fxLayout="row" class="row pr-0  pb-4 filtrosTable" autocomplete="off">
            <div class="col-md-2 col-lg-1 col-12">
                <mat-label class="lblblack">{{this.form.get('nroDocumento').value}}</mat-label>
            </div>
            <div class="col-md-2 col-lg-3 col-12 text-center">
                <mat-label>{{this.form.get('nombresApellidos').value}}</mat-label>
            </div>
            <div class="col-md-2 col-lg-2 col-12">
                <mat-label class="lblblack">Fecha afiliación</mat-label>
            </div>
            <div class="col-md-1 col-lg-1 col-12">
                <mat-label>{{this.form.get('fechaAfiliacion').value | fechapipe}}</mat-label>
            </div>
            <div class="col-md-1 col-lg-1 col-12">
                <mat-label class="lblblack">Producto</mat-label>
            </div>
            <div class="col-md-1 col-lg-2 col-12">
                <mat-label>{{this.form.get('productoInicial').value}}</mat-label>
            </div>
            <div class="col-md-1 col-lg-1 col-12">
                <mat-label class="lblblack">Edad</mat-label>
            </div>
            <div class="col-md-1 col-lg-1 col-12">
                <mat-label>{{this.form.get('edad').value}}</mat-label>
            </div>
        </div>
        <div [formGroup]="form" fxFlex="auto" fxLayout="row" class="row pr-0  pb-4 filtrosTable" autocomplete="off">
            <div class="col-md-2 col-lg-1 col-12">
                <mat-label class="lblblack">Estado</mat-label>
            </div>
            <div class="col-md-2 col-lg-2 col-12">
                <mat-label [class]="this.form.get('estadoColor').value">{{this.form.get('estado').value}}</mat-label>
            </div>
            <div class="col-md-1 col-lg-1 col-12" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">
                <mat-label class="lblblack">Tipo</mat-label>
            </div>
            <div class="col-md-1 col-lg-2 col-12" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">
                <mat-label [class]="this.form.get('estadoDescripcionColor').value">{{this.form.get('estadoDescripcion').value}}</mat-label>
            </div>
        </div>
    </div>
    <div class="estadoselec" [formGroup]="form">
        <div class="mat-elevation-z8 p-0 m-0 row">
            <div class="col-md-6 col-lg-6 offset-md-1 offset-lg-1">
                <div class="row">
                    <div class="col-md-12 col-lg-12" *ngIf="this.MostrarMotivo()">
                        <mat-form-field appearance="fill">
                            <mat-label>Motivo de la {{this.form.get('activoRegistro').value ? 'inactivación' : 'activación'}} (*)</mat-label>
                            <mat-select disableRipple formControlName="motivo">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listaMotivos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('motivo').hasError('required')">El Motivo es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6" *ngIf="this.form.get('activoRegistro').value === false && !this.registrarEstado">
                        <mat-form-field appearance="fill">
                            <mat-label>Producto (*)</mat-label>
                            <mat-select formControlName="idProducto">
                                <mat-option [value]="item.id" *ngFor="let item of this.ListaProductos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('idProducto').hasError('required')">El Producto es un campo requerido</mat-error>
                            <mat-error *ngIf="form.get('idProducto').hasError('min')">El Producto es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6" *ngIf="this.form.get('activoRegistro').value === false && !this.registrarEstado">
                        <mat-form-field appearance="fill">
                            <mat-label>Vigencia (*)</mat-label>
                            <mat-select formControlName="idProductoPlazo">
                                <mat-option [value]="item.id" *ngFor="let item of this.listaPlazoProducto">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('idProductoPlazo').hasError('required')">La Vigencia es un campo requerido</mat-error>
                            <mat-error *ngIf="form.get('idProductoPlazo').hasError('min')">La vigencia es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Correo electrónico (*)</mat-label>
                            <input matInput formControlName="email" autocomplete="off" autocomplete="new-password">
                            <mat-error *ngIf="form.get('email').hasError('required')">El Correo electrónico son un campo requerido</mat-error>
                            <mat-error *ngIf="form.get('email').hasError('maxlength')">La longitud máxima es 40</mat-error>
                            <mat-error *ngIf="form.get('email').hasError('email')">El Correo electronico no tiene formato correcto</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Movil (*)</mat-label>
                            <input matInput formControlName="movil" autocomplete="off">
                            <mat-error *ngIf="form.get('movil').hasError('required')">El Movil son un campo requerido</mat-error>
                            <mat-error *ngIf="form.get('movil').hasError('maxlength')">La longitud máxima es 20</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6" *ngIf="this.registrarEstado && this.permitirActualizarEstado">
                        <mat-form-field appearance="fill">
                            <mat-label>Estado (*)</mat-label>
                            <mat-select formControlName="idEstado">
                                <mat-option [value]="item.id" *ngFor="let item of this.listaEstados">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('idEstado').hasError('required')">El estado es un campo requerido</mat-error>
                            <mat-error *ngIf="form.get('idEstado').hasError('min')">El estado es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6" *ngIf="this.calculoPrecioEdad && !this.permitirIngresoPrecio">
                        <mat-form-field appearance="fill">
                            <mat-label>Plan (*)</mat-label>
                            <input matInput formControlName="idProductoEdadDescripcion" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6" *ngIf="this.permitirIngresoPrecio">
                        <mat-form-field appearance="fill">
                            <mat-label>Plan (*)</mat-label>
                            <input matInput type="number" formControlName="precioNuevo" autocomplete="off">
                            <mat-error *ngIf="form.get('precioNuevo').hasError('required')">El Plan es un campo requerido</mat-error>
                            <mat-error *ngIf="form.get('precioNuevo').hasError('min')">El Plan es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6" *ngIf="this.calculoPrecioEdad">
                        <mat-form-field appearance="fill">
                            <mat-label>Nro poliza</mat-label>
                            <input matInput formControlName="nroPoliza" autocomplete="off">
                            <mat-error *ngIf="form.get('nroPoliza').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-md-5 col-lg-5">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Observación</mat-label>
                    <textarea matInput formControlName="descripcionMotivo" rows="5"></textarea>
                    <mat-error *ngIf="form.get('descripcionMotivo').hasError('required')">La Observación es un campo requerido</mat-error>
                    <mat-error *ngIf="form.get('descripcionMotivo').hasError('maxLength')">La longitud máxima es 250 caracteres</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="mat-elevation-z8 p-0 m-0 row" *ngIf="this.permitirActualizarEstado">
            <div class="col-md-6 col-lg-6 offset-md-1 offset-lg-1"></div>
            <div class="col-md-5 col-lg-5">
                <button mat-button class="btnprimary crearafil float-right" (click)="ejecutarAccion()">
                    <span>{{this.tituloBoton}}</span>
                    <mat-icon>check_circle_outline</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>